"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const nodeTemplatesFromActions = (actions) => lodash_1.compact(actions.map(curr => {
    if (!curr)
        return null;
    const { id, serviceId, typeOf } = curr;
    return {
        action: id,
        selected_api: serviceId,
        type_of: typeOf,
    };
}));
exports.default = nodeTemplatesFromActions;
